const CUSTOMER_WORKFLOW = {
  CADASTRO_ENVIADO: {
    id: 1,
    description: 'Cadastro enviado',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_EM_ANDAMENTO, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO];
    },
  },
  CADASTRO_EM_ANDAMENTO: {
    id: 2,
    description: 'Cadastro em andamento',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_FINALIZADO, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO];
    },
  },
  CADASTRO_FINALIZADO: {
    id: 3,
    description: 'Cadastro finalizado',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_EM_ANALISE, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO];
    },
  },
  CADASTRO_EM_ANALISE: {
    id: 4,
    description: 'Cadastro em análise',
    next: () => {
      return [CUSTOMER_WORKFLOW.PENDECIA_DOCUMENTAL, CUSTOMER_WORKFLOW.ENVIADO_AO_BANCO, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO];
    },
  },
  PENDECIA_DOCUMENTAL: {
    id: 5,
    description: 'Pendência documental',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_EM_ANDAMENTO, CUSTOMER_WORKFLOW.ENVIADO_AO_BANCO, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO];
    },
  },
  ENVIADO_AO_BANCO: {
    id: 6,
    description: 'Enviado ao banco',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_APROVADO, CUSTOMER_WORKFLOW.CADASTRO_RECUSADO];
    },
  },
  CADASTRO_APROVADO: {
    id: 7,
    description: 'Cadastro aprovado',
    next: () => {
      return [];
    },
  },
  CADASTRO_RECUSADO: {
    id: 8,
    description: 'Cadastro recusado',
    next: () => {
      return [];
    },
  },
  CADASTRO_INATIVADO: {
    id: 9,
    description: 'Cadastro inativado',
    next: () => {
      return [];
    },
  },
}

const CUSTOMER_WORKFLOW_LIST = Object.values(CUSTOMER_WORKFLOW);

export  {
  CUSTOMER_WORKFLOW,
  CUSTOMER_WORKFLOW_LIST,
}